import _ from "lodash";
import { getIsCopyContentToDateRangeEnabled } from "Utils/ACLStoreUtils";

export const getSectionIdForTestId = sectionId => {
  const parts = sectionId.split("=>");
  const result = _.join([parts[1], parts[2].replace(/-/g, "_")], "_");
  return result;
};

export const getSectionId = sectionId => {
  return _.endsWith(sectionId, "_2") ? _.trimEnd(sectionId, "_2") : sectionId;
};

export const getCopyContentModalTitle = ({
  t,
  shareMode,
  selectedItemTitle,
}) => {
  const isCopyContentToDateRangeEnabled = getIsCopyContentToDateRangeEnabled();

  // Default title -> Move
  let titleLocale = "classPlanner:move_task_subtitle";

  if (shareMode === "REPEAT") {
    titleLocale = isCopyContentToDateRangeEnabled
      ? "classPlanner:copy_resource_to_multiple_blocks"
      : "classPlanner:copy_resource_to_title";
  }

  return t(titleLocale, {
    label: selectedItemTitle,
  });
};

export const getCopyContentModalSubtitle = ({
  t,
  shareMode,
  selectedItemTitle,
}) => {
  const isCopyContentToDateRangeEnabled = getIsCopyContentToDateRangeEnabled();

  // Default subtitle -> Move
  let subtitleLocale = "classPlanner:move_task_subtitle";

  if (shareMode === "REPEAT") {
    subtitleLocale = isCopyContentToDateRangeEnabled
      ? null
      : "classPlanner:repeat_task_subtitle";
  }

  return subtitleLocale
    ? t(subtitleLocale, {
        label: selectedItemTitle,
      })
    : "";
};
